var _rect, _defs, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _polyline, _line8, _line9, _line10, _line11, _polyline2, _polyline3, _line12, _line13, _polyline4, _line14, _line15, _polyline5, _polyline6, _line16, _line17, _line18, _polyline7, _polyline8, _polyline9, _line19, _line20, _line21, _polyline10, _line22, _line23, _polyline11, _polyline12, _polyline13, _polyline14, _line24, _line25, _polyline15, _polyline16, _polyline17, _polyline18, _line26, _line27, _polyline19, _line28, _line29, _polyline20, _polyline21, _polyline22, _polyline23, _line30, _line31, _line32, _polyline24, _polyline25, _polyline26, _line33, _line34, _polyline27, _line35, _line36, _line37, _polyline28, _polyline29, _line38, _line39, _line40, _line41, _polyline30, _polyline31, _line42, _line43, _polyline32, _line44, _line45, _polyline33, _polyline34, _line46, _line47, _line48, _line49, _polyline35, _polyline36, _line50, _line51, _polyline37, _line52, _line53, _polyline38, _polyline39, _line54, _line55, _line56, _polyline40, _line57, _line58, _polyline41, _polyline42, _line59, _line60, _line61, _line62, _polyline43, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _polyline44, _rect3, _rect4, _line104, _line105, _rect5, _rect6, _line106, _line107, _line108, _line109, _rect7, _rect8, _line110, _line111, _line112, _line113, _line114, _polyline45, _polyline46, _polyline47, _polyline48, _line115, _line116, _line117, _line118, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _line127, _line128, _line129, _line130, _line131, _line132, _line133, _line134, _line135, _line136, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _polyline49, _polyline50, _polyline51, _polyline52, _line146, _line147, _line148, _line149, _line150, _line151, _line152, _line153, _line154, _line155, _line156, _line157, _line158, _line159, _line160, _line161, _line162, _line163, _line164, _line165, _line166, _line167, _line168, _line169, _line170, _line171, _line172, _line173, _line174, _line175, _line176, _polyline53, _polyline54, _polyline55, _polyline56, _line177, _line178, _line179, _line180, _line181, _line182, _line183, _line184, _line185, _line186, _line187, _line188, _line189, _line190, _line191, _line192, _line193, _line194, _line195, _line196, _line197, _line198, _line199, _line200, _line201, _line202, _line203, _line204, _line205, _line206, _line207, _polyline57, _polyline58, _polyline59, _polyline60, _line208, _line209, _line210, _line211, _line212, _line213, _line214, _line215, _line216, _line217, _line218, _line219, _line220, _line221, _line222, _line223, _line224, _line225, _line226, _line227, _line228, _line229, _line230, _line231, _line232, _line233, _line234, _line235, _line236, _line237, _line238, _polyline61, _polyline62, _polyline63, _polyline64, _line239, _line240, _line241, _line242, _line243, _line244, _line245, _line246, _line247, _line248, _line249, _line250, _line251, _line252, _line253, _line254, _line255, _line256, _line257, _line258, _line259, _line260, _line261, _line262, _line263, _line264, _line265, _line266, _line267, _line268, _line269, _polyline65, _polyline66, _polyline67, _polyline68, _line270, _line271, _line272, _line273, _line274, _line275, _line276, _line277, _line278, _line279, _line280, _line281, _line282, _line283, _line284, _line285, _line286, _line287, _line288, _line289, _line290, _line291, _line292, _line293, _line294, _line295, _line296, _line297, _line298, _line299, _line300, _polyline69, _polyline70, _polyline71, _polyline72, _line301, _line302, _line303, _line304, _line305, _line306, _line307, _line308, _line309, _line310, _line311, _line312, _line313, _line314, _line315, _line316, _line317, _line318, _line319, _line320, _line321, _line322, _line323, _line324, _line325, _line326, _line327, _line328, _line329, _line330, _line331, _polyline73, _polyline74, _polyline75, _polyline76, _line332, _line333, _line334, _line335, _line336, _line337, _line338, _line339, _line340, _line341, _line342, _line343, _line344, _line345, _line346, _line347, _line348, _line349, _line350, _line351, _line352, _line353, _line354, _line355, _line356, _line357, _line358, _line359, _line360, _line361, _line362, _polyline77, _polyline78, _polyline79, _polyline80, _line363, _line364, _line365, _line366, _line367, _line368, _line369, _line370, _line371, _line372, _line373, _line374, _line375, _line376, _line377, _line378, _line379, _line380, _line381, _line382, _line383, _line384, _line385, _line386, _line387, _line388, _line389, _line390, _line391, _line392, _line393, _polyline81, _polyline82, _polyline83, _polyline84, _line394, _line395, _line396, _line397, _line398, _line399, _line400, _line401, _line402, _line403, _line404, _line405, _line406, _line407, _line408, _line409, _line410, _line411, _line412, _line413, _line414, _line415, _line416, _line417, _line418, _line419, _line420, _line421, _line422, _line423, _line424, _polyline85, _polyline86, _polyline87, _polyline88, _line425, _line426, _line427, _line428, _line429, _line430, _line431, _line432, _line433, _line434, _line435, _line436, _line437, _line438, _line439, _line440, _line441, _line442, _line443, _line444, _line445, _line446, _line447, _line448, _line449, _line450, _line451, _line452, _line453, _line454, _line455, _polyline89, _polyline90, _polyline91, _polyline92, _line456, _line457, _line458, _line459, _line460, _line461, _line462, _line463, _line464, _line465, _line466, _line467, _line468, _line469, _line470, _line471, _line472, _line473, _line474, _line475, _line476, _line477, _line478, _line479, _line480, _line481, _line482, _line483, _line484, _rect9, _line485, _line486, _line487;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamiMapsCpSubArea2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1224 792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: square;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-width: .75px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1014.19,
    y: 374.78,
    width: 2.27,
    height: 2.23
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 967.45,
    y1: 378.5,
    x2: 967.67,
    y2: 378.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 967.67,
    y1: 378.5,
    x2: 968.05,
    y2: 378.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 492.4,
    y1: 378.5,
    x2: 492.78,
    y2: 378.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 492.78,
    y1: 378.5,
    x2: 492.93,
    y2: 378.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 373.75,
    y1: 378.5,
    x2: 373.9,
    y2: 378.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 373.9,
    y1: 378.5,
    x2: 374.28,
    y2: 378.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 255.03,
    y1: 378.5,
    x2: 255.41,
    y2: 378.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "969.34 466.66 965.78 466.66 965.78 467.03 967.45 467.03"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.45,
    y1: 467.18,
    x2: 967.45,
    y2: 467.03
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.45,
    y1: 467.18,
    x2: 967.45,
    y2: 470.15
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.67,
    y1: 470.15,
    x2: 967.67,
    y2: 467.18
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.67,
    y1: 467.03,
    x2: 967.67,
    y2: 467.18
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "967.67 467.03 969.34 467.03 969.34 466.66"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "969.34 375.16 965.78 375.16 965.78 375.31 967.45 375.31"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.45,
    y1: 375.68,
    x2: 967.45,
    y2: 375.31
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.45,
    y1: 375.68,
    x2: 967.45,
    y2: 378.5
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "967.45 378.5 965.78 378.5 965.78 378.87 969.34 378.87 969.34 378.5 967.67 378.5"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.67,
    y1: 378.5,
    x2: 967.67,
    y2: 375.68
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.67,
    y1: 375.31,
    x2: 967.67,
    y2: 375.68
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "967.67 375.31 969.34 375.31 969.34 375.16"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "850.46 466.66 847.05 466.66 847.05 467.03 848.57 467.03"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 848.95,
    y1: 467.18,
    x2: 848.57,
    y2: 467.03
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 848.95,
    y1: 467.18,
    x2: 848.95,
    y2: 470.15
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 848.95,
    y1: 470.15,
    x2: 848.95,
    y2: 467.18
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "849.18 467.03 848.95 467.03 848.95 467.18"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "849.18 467.03 850.46 467.03 850.46 466.66"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "850.46 375.16 847.05 375.16 847.05 375.31 848.57 375.31"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 848.95,
    y1: 375.68,
    x2: 848.57,
    y2: 375.31
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 848.95,
    y1: 375.68,
    x2: 848.95,
    y2: 378.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 848.57,
    y1: 378.5,
    x2: 848.95,
    y2: 378.5
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "848.57 378.5 847.05 378.5 847.05 378.87 850.46 378.87 850.46 378.5 849.18 378.5"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 848.95,
    y1: 378.5,
    x2: 849.18,
    y2: 378.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 848.95,
    y1: 378.5,
    x2: 848.95,
    y2: 375.68
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "849.18 375.31 848.95 375.31 848.95 375.68"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "849.18 375.31 850.46 375.31 850.46 375.16"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "732.04 466.66 728.26 466.66 728.26 467.03 729.92 467.03"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "730.15 467.18 730.15 467.03 729.92 467.03"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 730.15,
    y1: 467.18,
    x2: 730.15,
    y2: 470.15
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 730.15,
    y1: 470.15,
    x2: 730.15,
    y2: 467.18
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "730.3 467.03 730.15 467.03 730.15 467.18"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "730.3 467.03 732.04 467.03 732.04 466.66"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "732.04 375.16 728.26 375.16 728.26 375.31 729.92 375.31"
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "730.15 375.68 730.15 375.31 729.92 375.31"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 730.15,
    y1: 375.68,
    x2: 730.15,
    y2: 378.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 729.92,
    y1: 378.5,
    x2: 730.15,
    y2: 378.5
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "729.92 378.5 728.26 378.5 728.26 378.87 732.04 378.87 732.04 378.5 730.3 378.5"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 730.15,
    y1: 378.5,
    x2: 730.3,
    y2: 378.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 730.15,
    y1: 378.5,
    x2: 730.15,
    y2: 375.68
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "730.3 375.31 730.15 375.31 730.15 375.68"
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "730.3 375.31 732.04 375.31 732.04 375.16"
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "613.17 466.66 609.76 466.66 609.76 467.03 611.05 467.03"
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "611.27 467.18 611.27 467.03 611.05 467.03"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 611.27,
    y1: 467.18,
    x2: 611.27,
    y2: 470.15
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 611.27,
    y1: 470.15,
    x2: 611.27,
    y2: 467.18
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 611.65,
    y1: 467.03,
    x2: 611.27,
    y2: 467.18
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "611.65 467.03 613.17 467.03 613.17 466.66"
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "613.17 375.16 609.76 375.16 609.76 375.31 611.05 375.31"
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "611.27 375.68 611.27 375.31 611.05 375.31"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 611.27,
    y1: 375.68,
    x2: 611.27,
    y2: 378.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 611.05,
    y1: 378.5,
    x2: 611.27,
    y2: 378.5
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "611.05 378.5 609.76 378.5 609.76 378.87 613.17 378.87 613.17 378.5 611.65 378.5"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 611.27,
    y1: 378.5,
    x2: 611.65,
    y2: 378.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 611.27,
    y1: 378.5,
    x2: 611.27,
    y2: 375.68
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 611.65,
    y1: 375.31,
    x2: 611.27,
    y2: 375.68
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "611.65 375.31 613.17 375.31 613.17 375.16"
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "494.29 466.66 490.88 466.66 490.88 467.03 492.4 467.03"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.4,
    y1: 467.18,
    x2: 492.4,
    y2: 467.03
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.4,
    y1: 467.18,
    x2: 492.4,
    y2: 470.15
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.78,
    y1: 470.15,
    x2: 492.78,
    y2: 467.18
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.78,
    y1: 467.03,
    x2: 492.78,
    y2: 467.18
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "492.78 467.03 494.29 467.03 494.29 466.66"
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "494.29 375.16 490.88 375.16 490.88 375.31 492.4 375.31"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.4,
    y1: 375.68,
    x2: 492.4,
    y2: 375.31
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.4,
    y1: 375.68,
    x2: 492.4,
    y2: 378.5
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "492.4 378.5 490.88 378.5 490.88 378.87 494.29 378.87 494.29 378.5 492.78 378.5"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.78,
    y1: 378.5,
    x2: 492.78,
    y2: 375.68
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.78,
    y1: 375.31,
    x2: 492.78,
    y2: 375.68
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "492.78 375.31 494.29 375.31 494.29 375.16"
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "375.65 466.66 372.01 466.66 372.01 467.03 373.75 467.03"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 373.75,
    y1: 467.18,
    x2: 373.75,
    y2: 467.03
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 373.75,
    y1: 467.18,
    x2: 373.75,
    y2: 470.15
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 373.9,
    y1: 470.15,
    x2: 373.9,
    y2: 467.18
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 373.9,
    y1: 467.03,
    x2: 373.9,
    y2: 467.18
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "373.9 467.03 375.65 467.03 375.65 466.66"
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "375.65 375.16 372.01 375.16 372.01 375.31 373.75 375.31"
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 373.75,
    y1: 375.68,
    x2: 373.75,
    y2: 375.31
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 373.75,
    y1: 375.68,
    x2: 373.75,
    y2: 378.5
  })), _polyline37 || (_polyline37 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "373.75 378.5 372.01 378.5 372.01 378.87 375.65 378.87 375.65 378.5 373.9 378.5"
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 373.9,
    y1: 378.5,
    x2: 373.9,
    y2: 375.68
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 373.9,
    y1: 375.31,
    x2: 373.9,
    y2: 375.68
  })), _polyline38 || (_polyline38 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "373.9 375.31 375.65 375.31 375.65 375.16"
  })), _polyline39 || (_polyline39 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "256.77 375.16 253.13 375.16 253.13 375.31 254.88 375.31"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.03,
    y1: 375.68,
    x2: 254.88,
    y2: 375.31
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.03,
    y1: 375.68,
    x2: 255.03,
    y2: 378.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 254.88,
    y1: 378.5,
    x2: 255.03,
    y2: 378.5
  })), _polyline40 || (_polyline40 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "254.88 378.5 253.13 378.5 253.13 378.87 256.77 378.87 256.77 378.5 255.03 378.5"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.03,
    y1: 378.5,
    x2: 255.03,
    y2: 375.68
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.03,
    y1: 375.31,
    x2: 255.03,
    y2: 375.68
  })), _polyline41 || (_polyline41 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.03 375.31 256.77 375.31 256.77 375.16"
  })), _polyline42 || (_polyline42 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "256.77 466.66 253.13 466.66 253.13 467.03 254.88 467.03"
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.03,
    y1: 467.18,
    x2: 254.88,
    y2: 467.03
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.03,
    y1: 467.18,
    x2: 255.03,
    y2: 470.15
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.03,
    y1: 470.15,
    x2: 255.03,
    y2: 467.18
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.03,
    y1: 467.03,
    x2: 255.03,
    y2: 467.18
  })), _polyline43 || (_polyline43 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "255.03 467.03 256.77 467.03 256.77 466.66"
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1039.19,
    y1: 319.53,
    x2: 1039.19,
    y2: 462.38
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1039.19,
    y1: 319.53,
    x2: 1025.18,
    y2: 305.79
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 245.03,
    y1: 297.77,
    x2: 245.03,
    y2: 379.76
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 243.51,
    y1: 298.51,
    x2: 243.51,
    y2: 377.91
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 245.03,
    y1: 379.76,
    x2: 245.03,
    y2: 374.19
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 242.98,
    y1: 351.17,
    x2: 242.98,
    y2: 376.42
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 242.75,
    y1: 343.74,
    x2: 242.75,
    y2: 323.09
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 242.75,
    y1: 308.76,
    x2: 242.75,
    y2: 319.01
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1000.78,
    y1: 343.15,
    x2: 1000.78,
    y2: 451.58
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 342.63,
    x2: 1001.54,
    y2: 452.32
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1016.46,
    y1: 342.63,
    x2: 1016.46,
    y2: 472
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1015.71,
    y1: 342.63,
    x2: 1015.71,
    y2: 471.48
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 447.87,
    x2: 1015.71,
    y2: 447.87
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1000.18,
    y1: 452.32,
    x2: 1001.54,
    y2: 452.32
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1000.18,
    y1: 451.58,
    x2: 1000.78,
    y2: 451.58
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 443.78,
    x2: 1015.71,
    y2: 443.78
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 440.22,
    x2: 1015.71,
    y2: 440.22
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 436.5,
    x2: 1015.71,
    y2: 436.5
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 432.42,
    x2: 1015.71,
    y2: 432.42
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 428.71,
    x2: 1015.71,
    y2: 428.71
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 424.99,
    x2: 1015.71,
    y2: 424.99
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 421.06,
    x2: 1015.71,
    y2: 421.06
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 417.34,
    x2: 1015.71,
    y2: 417.34
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 400.63,
    x2: 1015.71,
    y2: 400.63
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 396.92,
    x2: 1015.71,
    y2: 396.92
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 392.83,
    x2: 1015.71,
    y2: 392.83
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 389.12,
    x2: 1015.71,
    y2: 389.12
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 385.41,
    x2: 1015.71,
    y2: 385.41
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 381.47,
    x2: 1015.71,
    y2: 381.47
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 377.76,
    x2: 1015.71,
    y2: 377.76
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 373.82,
    x2: 1015.71,
    y2: 373.82
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 370.11,
    x2: 1015.71,
    y2: 370.11
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 366.39,
    x2: 1015.71,
    y2: 366.39
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 362.31,
    x2: 1015.71,
    y2: 362.31
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 358.6,
    x2: 1015.71,
    y2: 358.6
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 354.66,
    x2: 1015.71,
    y2: 354.66
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 350.95,
    x2: 1015.71,
    y2: 350.95
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1015.71,
    y1: 342.63,
    x2: 1016.46,
    y2: 342.63
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1001.54,
    y1: 342.63,
    x2: 1000.18,
    y2: 342.63
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1000.78,
    y1: 343.15,
    x2: 1000.18,
    y2: 343.15
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1000.18,
    y1: 466.06,
    x2: 1012.9,
    y2: 466.06
  })), _polyline44 || (_polyline44 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "1012.9 466.06 1011.39 460.12 1006.46 455.29 1000.18 453.59"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 998.28,
    y: 452.84,
    width: 1.89,
    height: 0.74
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 998.28,
    y: 466.1,
    width: 1.89,
    height: 0.93
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 765.53,
    y1: 472.23,
    x2: 773.11,
    y2: 464.8
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 765.53,
    y1: 464.8,
    x2: 773.11,
    y2: 472.23
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 765.3,
    y: 464.23,
    width: 8.33,
    height: 8.37
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 765.53,
    y: 464.79,
    width: 7.57,
    height: 7.44
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 250.56,
    y1: 381.62,
    x2: 250.56,
    y2: 398.4
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 251.32,
    y1: 381.62,
    x2: 251.32,
    y2: 398.4
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 765.53,
    y1: 472.23,
    x2: 773.11,
    y2: 464.8
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 765.53,
    y1: 464.8,
    x2: 773.11,
    y2: 472.23
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 765.3,
    y: 464.23,
    width: 8.33,
    height: 8.37
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 765.53,
    y: 464.79,
    width: 7.57,
    height: 7.44
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 250.56,
    y1: 381.62,
    x2: 250.56,
    y2: 398.4
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 251.32,
    y1: 381.62,
    x2: 251.32,
    y2: 398.4
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.03,
    y1: 461.61,
    x2: 255.03,
    y2: 475.35
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 313.37,
    y1: 398.4,
    x2: 313.37,
    y2: 388.53
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 304.05,
    y1: 398.4,
    x2: 304.05,
    y2: 388.53
  })), _polyline45 || (_polyline45 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "300.26 398.92 300.11 398.92 300.11 399.52"
  })), _polyline46 || (_polyline46 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "300.11 412.37 300.11 412.52 300.26 412.52"
  })), _polyline47 || (_polyline47 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "314.88 412.52 315.26 412.52 315.26 412.37"
  })), _polyline48 || (_polyline48 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "315.26 399.52 315.26 398.92 314.88 398.92"
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 314.88,
    y1: 412.52,
    x2: 300.26,
    y2: 412.52
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 315.26,
    y1: 399.52,
    x2: 315.26,
    y2: 412.37
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 300.26,
    y1: 398.92,
    x2: 314.88,
    y2: 398.92
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 312.76,
    y1: 419.2,
    x2: 312.76,
    y2: 412.74
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 302.53,
    y1: 419.2,
    x2: 302.53,
    y2: 412.74
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 304.05,
    y1: 398.4,
    x2: 313.37,
    y2: 398.4
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 304.05,
    y1: 388.53,
    x2: 313.37,
    y2: 388.53
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 302.53,
    y1: 419.2,
    x2: 312.76,
    y2: 419.2
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 300.11,
    y1: 412.37,
    x2: 300.11,
    y2: 399.52
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 298.82,
    y1: 393.35,
    x2: 298.82,
    y2: 419.79
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 315.26,
    y1: 419.79,
    x2: 315.26,
    y2: 432.79
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 315.26,
    y1: 432.79,
    x2: 276.24,
    y2: 432.79
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 298.82,
    y1: 393.35,
    x2: 276.24,
    y2: 393.35
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 276.24,
    y1: 393.35,
    x2: 276.24,
    y2: 432.79
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 298.82,
    y1: 419.79,
    x2: 315.26,
    y2: 419.79
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 276.24,
    y1: 432.79,
    x2: 276.24,
    y2: 431.9
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 308.82,
    y1: 373.45,
    x2: 308.82,
    y2: 388.38
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 300.87,
    y1: 373.45,
    x2: 305.41,
    y2: 373.45
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 300.87,
    y1: 388.38,
    x2: 308.82,
    y2: 388.38
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 300.87,
    y1: 373.45,
    x2: 300.87,
    y2: 388.38
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 307.31,
    y1: 373.45,
    x2: 308.82,
    y2: 373.45
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 273.21,
    y1: 369.22,
    x2: 311.47,
    y2: 369.22
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 273.21,
    y1: 369.22,
    x2: 273.21,
    y2: 367.14
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 270.18,
    y1: 367.14,
    x2: 273.21,
    y2: 367.14
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 311.47,
    y1: 331.04,
    x2: 270.18,
    y2: 331.04
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 311.47,
    y1: 369.22,
    x2: 311.47,
    y2: 331.04
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 270.18,
    y1: 367.14,
    x2: 270.18,
    y2: 331.04
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 307.31,
    y1: 369.22,
    x2: 307.31,
    y2: 373.45
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 305.41,
    y1: 369.22,
    x2: 305.41,
    y2: 373.45
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 370.87,
    y1: 398.4,
    x2: 370.87,
    y2: 388.53
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 361.78,
    y1: 398.4,
    x2: 361.78,
    y2: 388.53
  })), _polyline49 || (_polyline49 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "357.99 398.92 357.61 398.92 357.61 399.52"
  })), _polyline50 || (_polyline50 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "357.61 412.37 357.61 412.52 357.99 412.52"
  })), _polyline51 || (_polyline51 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "372.61 412.52 372.77 412.52 372.77 412.37"
  })), _polyline52 || (_polyline52 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "372.77 399.52 372.77 398.92 372.61 398.92"
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 372.61,
    y1: 412.52,
    x2: 357.99,
    y2: 412.52
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 372.77,
    y1: 399.52,
    x2: 372.77,
    y2: 412.37
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 357.99,
    y1: 398.92,
    x2: 372.61,
    y2: 398.92
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 370.49,
    y1: 419.2,
    x2: 370.49,
    y2: 412.74
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 360.11,
    y1: 419.2,
    x2: 360.11,
    y2: 412.74
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 361.78,
    y1: 398.4,
    x2: 370.87,
    y2: 398.4
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 361.78,
    y1: 388.53,
    x2: 370.87,
    y2: 388.53
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 360.11,
    y1: 419.2,
    x2: 370.49,
    y2: 419.2
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 357.61,
    y1: 412.37,
    x2: 357.61,
    y2: 399.52
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 356.33,
    y1: 393.35,
    x2: 356.33,
    y2: 419.79
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 372.77,
    y1: 419.79,
    x2: 372.77,
    y2: 432.79
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 372.77,
    y1: 432.79,
    x2: 333.97,
    y2: 432.79
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 356.33,
    y1: 393.35,
    x2: 333.97,
    y2: 393.35
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 333.97,
    y1: 393.35,
    x2: 333.97,
    y2: 432.79
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 356.33,
    y1: 419.79,
    x2: 372.77,
    y2: 419.79
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 333.97,
    y1: 432.79,
    x2: 333.97,
    y2: 431.9
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 366.33,
    y1: 373.45,
    x2: 366.33,
    y2: 388.38
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 358.6,
    y1: 373.45,
    x2: 363.14,
    y2: 373.45
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 358.6,
    y1: 388.38,
    x2: 366.33,
    y2: 388.38
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 358.6,
    y1: 373.45,
    x2: 358.6,
    y2: 388.38
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 365.04,
    y1: 373.45,
    x2: 366.33,
    y2: 373.45
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 330.57,
    y1: 369.22,
    x2: 368.98,
    y2: 369.22
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 330.57,
    y1: 369.22,
    x2: 330.57,
    y2: 367.14
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 327.91,
    y1: 367.14,
    x2: 330.57,
    y2: 367.14
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 368.98,
    y1: 331.04,
    x2: 327.91,
    y2: 331.04
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 368.98,
    y1: 369.22,
    x2: 368.98,
    y2: 331.04
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 327.91,
    y1: 367.14,
    x2: 327.91,
    y2: 331.04
  })), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 365.04,
    y1: 369.22,
    x2: 365.04,
    y2: 373.45
  })), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 363.14,
    y1: 369.22,
    x2: 363.14,
    y2: 373.45
  })), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 435.65,
    y1: 398.4,
    x2: 435.65,
    y2: 388.53
  })), _line176 || (_line176 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 426.56,
    y1: 398.4,
    x2: 426.56,
    y2: 388.53
  })), _polyline53 || (_polyline53 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "422.77 398.92 422.39 398.92 422.17 399.52"
  })), _polyline54 || (_polyline54 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "422.17 412.37 422.39 412.52 422.77 412.52"
  })), _polyline55 || (_polyline55 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "436.94 412.52 437.32 412.52 437.55 412.37"
  })), _polyline56 || (_polyline56 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "437.55 399.52 437.32 398.92 436.94 398.92"
  })), _line177 || (_line177 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 436.94,
    y1: 412.52,
    x2: 422.77,
    y2: 412.52
  })), _line178 || (_line178 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 437.55,
    y1: 399.52,
    x2: 437.55,
    y2: 412.37
  })), _line179 || (_line179 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 422.77,
    y1: 398.92,
    x2: 436.94,
    y2: 398.92
  })), _line180 || (_line180 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 435.05,
    y1: 419.2,
    x2: 435.05,
    y2: 412.74
  })), _line181 || (_line181 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 424.67,
    y1: 419.2,
    x2: 424.67,
    y2: 412.74
  })), _line182 || (_line182 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 426.56,
    y1: 398.4,
    x2: 435.65,
    y2: 398.4
  })), _line183 || (_line183 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 426.18,
    y1: 388.53,
    x2: 435.65,
    y2: 388.53
  })), _line184 || (_line184 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 424.67,
    y1: 419.2,
    x2: 435.05,
    y2: 419.2
  })), _line185 || (_line185 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 422.17,
    y1: 412.37,
    x2: 422.17,
    y2: 399.52
  })), _line186 || (_line186 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 420.88,
    y1: 393.35,
    x2: 420.88,
    y2: 419.79
  })), _line187 || (_line187 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 437.55,
    y1: 419.79,
    x2: 437.55,
    y2: 432.79
  })), _line188 || (_line188 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 437.55,
    y1: 432.79,
    x2: 398.53,
    y2: 432.79
  })), _line189 || (_line189 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 420.88,
    y1: 393.35,
    x2: 398.53,
    y2: 393.35
  })), _line190 || (_line190 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 398.53,
    y1: 393.35,
    x2: 398.53,
    y2: 432.79
  })), _line191 || (_line191 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 420.88,
    y1: 419.79,
    x2: 437.55,
    y2: 419.79
  })), _line192 || (_line192 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 398.53,
    y1: 432.79,
    x2: 398.53,
    y2: 431.9
  })), _line193 || (_line193 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 430.73,
    y1: 373.45,
    x2: 430.73,
    y2: 388.38
  })), _line194 || (_line194 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 423.15,
    y1: 373.45,
    x2: 427.85,
    y2: 373.45
  })), _line195 || (_line195 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 423.15,
    y1: 388.38,
    x2: 430.73,
    y2: 388.38
  })), _line196 || (_line196 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 423.15,
    y1: 373.45,
    x2: 423.15,
    y2: 388.38
  })), _line197 || (_line197 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 429.36,
    y1: 373.45,
    x2: 430.73,
    y2: 373.45
  })), _line198 || (_line198 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 395.34,
    y1: 369.22,
    x2: 433.76,
    y2: 369.22
  })), _line199 || (_line199 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 395.34,
    y1: 369.22,
    x2: 395.34,
    y2: 367.14
  })), _line200 || (_line200 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 392.69,
    y1: 367.14,
    x2: 395.34,
    y2: 367.14
  })), _line201 || (_line201 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 433.76,
    y1: 331.04,
    x2: 392.69,
    y2: 331.04
  })), _line202 || (_line202 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 433.76,
    y1: 369.22,
    x2: 433.76,
    y2: 331.04
  })), _line203 || (_line203 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 392.69,
    y1: 367.14,
    x2: 392.69,
    y2: 331.04
  })), _line204 || (_line204 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 429.36,
    y1: 369.22,
    x2: 429.36,
    y2: 373.45
  })), _line205 || (_line205 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 427.85,
    y1: 369.22,
    x2: 427.85,
    y2: 373.45
  })), _line206 || (_line206 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.93,
    y1: 398.4,
    x2: 492.93,
    y2: 388.53
  })), _line207 || (_line207 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 484.07,
    y1: 398.4,
    x2: 484.07,
    y2: 388.53
  })), _polyline57 || (_polyline57 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "480.28 398.92 480.13 398.92 479.75 399.52"
  })), _polyline58 || (_polyline58 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "479.75 412.37 480.13 412.52 480.28 412.52"
  })), _polyline59 || (_polyline59 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "494.67 412.52 494.82 412.52 495.2 412.37"
  })), _polyline60 || (_polyline60 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "495.2 399.52 494.82 398.92 494.67 398.92"
  })), _line208 || (_line208 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 494.67,
    y1: 412.52,
    x2: 480.28,
    y2: 412.52
  })), _line209 || (_line209 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 495.2,
    y1: 399.52,
    x2: 495.2,
    y2: 412.37
  })), _line210 || (_line210 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 480.28,
    y1: 398.92,
    x2: 494.67,
    y2: 398.92
  })), _line211 || (_line211 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 492.78,
    y1: 419.2,
    x2: 492.78,
    y2: 412.74
  })), _line212 || (_line212 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 482.17,
    y1: 419.2,
    x2: 482.17,
    y2: 412.74
  })), _line213 || (_line213 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 484.07,
    y1: 398.4,
    x2: 492.93,
    y2: 398.4
  })), _line214 || (_line214 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 483.91,
    y1: 388.53,
    x2: 492.93,
    y2: 388.53
  })), _line215 || (_line215 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 482.17,
    y1: 419.2,
    x2: 492.78,
    y2: 419.2
  })), _line216 || (_line216 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 479.75,
    y1: 412.37,
    x2: 479.75,
    y2: 399.52
  })), _line217 || (_line217 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 478.38,
    y1: 393.35,
    x2: 478.38,
    y2: 419.79
  })), _line218 || (_line218 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 495.2,
    y1: 419.79,
    x2: 495.2,
    y2: 432.79
  })), _line219 || (_line219 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 495.2,
    y1: 432.79,
    x2: 456.26,
    y2: 432.79
  })), _line220 || (_line220 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 478.38,
    y1: 393.35,
    x2: 456.26,
    y2: 393.35
  })), _line221 || (_line221 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 456.26,
    y1: 393.35,
    x2: 456.26,
    y2: 432.79
  })), _line222 || (_line222 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 478.38,
    y1: 419.79,
    x2: 495.2,
    y2: 419.79
  })), _line223 || (_line223 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 456.26,
    y1: 432.79,
    x2: 456.26,
    y2: 431.9
  })), _line224 || (_line224 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 488.46,
    y1: 373.45,
    x2: 488.46,
    y2: 388.38
  })), _line225 || (_line225 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 480.88,
    y1: 373.45,
    x2: 485.2,
    y2: 373.45
  })), _line226 || (_line226 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 480.88,
    y1: 388.38,
    x2: 488.46,
    y2: 388.38
  })), _line227 || (_line227 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 480.88,
    y1: 373.45,
    x2: 480.88,
    y2: 388.38
  })), _line228 || (_line228 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 487.1,
    y1: 373.45,
    x2: 488.46,
    y2: 373.45
  })), _line229 || (_line229 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 453,
    y1: 369.22,
    x2: 491.49,
    y2: 369.22
  })), _line230 || (_line230 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 453,
    y1: 369.22,
    x2: 453,
    y2: 367.14
  })), _line231 || (_line231 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 450.2,
    y1: 367.14,
    x2: 453,
    y2: 367.14
  })), _line232 || (_line232 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 491.49,
    y1: 331.04,
    x2: 450.2,
    y2: 331.04
  })), _line233 || (_line233 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 491.49,
    y1: 369.22,
    x2: 491.49,
    y2: 331.04
  })), _line234 || (_line234 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 450.2,
    y1: 367.14,
    x2: 450.2,
    y2: 331.04
  })), _line235 || (_line235 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 487.1,
    y1: 369.22,
    x2: 487.1,
    y2: 373.45
  })), _line236 || (_line236 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 485.2,
    y1: 369.22,
    x2: 485.2,
    y2: 373.45
  })), _line237 || (_line237 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 550.66,
    y1: 398.4,
    x2: 550.66,
    y2: 388.53
  })), _line238 || (_line238 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 541.42,
    y1: 398.4,
    x2: 541.42,
    y2: 388.53
  })), _polyline61 || (_polyline61 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "538.01 398.92 537.48 398.92 537.48 399.52"
  })), _polyline62 || (_polyline62 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "537.48 412.37 537.48 412.52 538.01 412.52"
  })), _polyline63 || (_polyline63 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "552.18 412.52 552.56 412.52 552.78 412.37"
  })), _polyline64 || (_polyline64 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "552.78 399.52 552.56 398.92 552.18 398.92"
  })), _line239 || (_line239 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 552.18,
    y1: 412.52,
    x2: 538.01,
    y2: 412.52
  })), _line240 || (_line240 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 552.78,
    y1: 399.52,
    x2: 552.78,
    y2: 412.37
  })), _line241 || (_line241 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 538.01,
    y1: 398.92,
    x2: 552.18,
    y2: 398.92
  })), _line242 || (_line242 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 550.28,
    y1: 419.2,
    x2: 550.28,
    y2: 412.74
  })), _line243 || (_line243 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 539.9,
    y1: 419.2,
    x2: 539.9,
    y2: 412.74
  })), _line244 || (_line244 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 541.42,
    y1: 398.4,
    x2: 550.66,
    y2: 398.4
  })), _line245 || (_line245 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 541.42,
    y1: 388.53,
    x2: 550.66,
    y2: 388.53
  })), _line246 || (_line246 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 539.9,
    y1: 419.2,
    x2: 550.28,
    y2: 419.2
  })), _line247 || (_line247 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 537.48,
    y1: 412.37,
    x2: 537.48,
    y2: 399.52
  })), _line248 || (_line248 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 536.12,
    y1: 393.35,
    x2: 536.12,
    y2: 419.79
  })), _line249 || (_line249 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 552.78,
    y1: 419.79,
    x2: 552.78,
    y2: 432.79
  })), _line250 || (_line250 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 552.78,
    y1: 432.79,
    x2: 513.76,
    y2: 432.79
  })), _line251 || (_line251 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 536.12,
    y1: 393.35,
    x2: 513.76,
    y2: 393.35
  })), _line252 || (_line252 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 513.76,
    y1: 393.35,
    x2: 513.76,
    y2: 432.79
  })), _line253 || (_line253 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 536.12,
    y1: 419.79,
    x2: 552.78,
    y2: 419.79
  })), _line254 || (_line254 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 513.76,
    y1: 432.79,
    x2: 513.76,
    y2: 431.9
  })), _line255 || (_line255 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 546.12,
    y1: 373.45,
    x2: 546.12,
    y2: 388.38
  })), _line256 || (_line256 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 538.62,
    y1: 373.45,
    x2: 542.71,
    y2: 373.45
  })), _line257 || (_line257 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 538.62,
    y1: 388.38,
    x2: 546.12,
    y2: 388.38
  })), _line258 || (_line258 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 538.62,
    y1: 373.45,
    x2: 538.62,
    y2: 388.38
  })), _line259 || (_line259 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 544.6,
    y1: 373.45,
    x2: 546.12,
    y2: 373.45
  })), _line260 || (_line260 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 510.58,
    y1: 369.22,
    x2: 549,
    y2: 369.22
  })), _line261 || (_line261 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 510.58,
    y1: 369.22,
    x2: 510.58,
    y2: 367.14
  })), _line262 || (_line262 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 507.7,
    y1: 367.14,
    x2: 510.58,
    y2: 367.14
  })), _line263 || (_line263 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 549,
    y1: 331.04,
    x2: 507.7,
    y2: 331.04
  })), _line264 || (_line264 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 549,
    y1: 369.22,
    x2: 549,
    y2: 331.04
  })), _line265 || (_line265 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 507.7,
    y1: 367.14,
    x2: 507.7,
    y2: 331.04
  })), _line266 || (_line266 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 544.6,
    y1: 369.22,
    x2: 544.6,
    y2: 373.45
  })), _line267 || (_line267 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 542.71,
    y1: 369.22,
    x2: 542.71,
    y2: 373.45
  })), _line268 || (_line268 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 608.24,
    y1: 398.4,
    x2: 608.24,
    y2: 388.53
  })), _line269 || (_line269 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 599.15,
    y1: 398.4,
    x2: 599.15,
    y2: 388.53
  })), _polyline65 || (_polyline65 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "595.36 398.92 594.98 398.92 594.98 399.52"
  })), _polyline66 || (_polyline66 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "594.98 412.37 594.98 412.52 595.36 412.52"
  })), _polyline67 || (_polyline67 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "609.91 412.52 610.14 412.52 610.14 412.37"
  })), _polyline68 || (_polyline68 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "610.14 399.52 610.14 398.92 609.91 398.92"
  })), _line270 || (_line270 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 609.91,
    y1: 412.52,
    x2: 595.36,
    y2: 412.52
  })), _line271 || (_line271 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 610.14,
    y1: 399.52,
    x2: 610.14,
    y2: 412.37
  })), _line272 || (_line272 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 595.36,
    y1: 398.92,
    x2: 609.91,
    y2: 398.92
  })), _line273 || (_line273 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 607.86,
    y1: 419.2,
    x2: 607.86,
    y2: 412.74
  })), _line274 || (_line274 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 597.41,
    y1: 419.2,
    x2: 597.41,
    y2: 412.74
  })), _line275 || (_line275 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 599.15,
    y1: 398.4,
    x2: 608.24,
    y2: 398.4
  })), _line276 || (_line276 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 599.15,
    y1: 388.53,
    x2: 608.24,
    y2: 388.53
  })), _line277 || (_line277 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 597.41,
    y1: 419.2,
    x2: 607.86,
    y2: 419.2
  })), _line278 || (_line278 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 594.98,
    y1: 412.37,
    x2: 594.98,
    y2: 399.52
  })), _line279 || (_line279 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 593.62,
    y1: 393.35,
    x2: 593.62,
    y2: 419.79
  })), _line280 || (_line280 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 610.14,
    y1: 419.79,
    x2: 610.14,
    y2: 432.79
  })), _line281 || (_line281 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 610.14,
    y1: 432.79,
    x2: 571.35,
    y2: 432.79
  })), _line282 || (_line282 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 593.62,
    y1: 393.35,
    x2: 571.35,
    y2: 393.35
  })), _line283 || (_line283 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 571.35,
    y1: 393.35,
    x2: 571.35,
    y2: 432.79
  })), _line284 || (_line284 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 593.62,
    y1: 419.79,
    x2: 610.14,
    y2: 419.79
  })), _line285 || (_line285 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 571.35,
    y1: 432.79,
    x2: 571.35,
    y2: 431.9
  })), _line286 || (_line286 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 603.7,
    y1: 373.45,
    x2: 603.7,
    y2: 388.38
  })), _line287 || (_line287 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 595.89,
    y1: 373.45,
    x2: 600.44,
    y2: 373.45
  })), _line288 || (_line288 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 595.89,
    y1: 388.38,
    x2: 603.7,
    y2: 388.38
  })), _line289 || (_line289 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 595.89,
    y1: 373.45,
    x2: 595.89,
    y2: 388.38
  })), _line290 || (_line290 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 602.33,
    y1: 373.45,
    x2: 603.7,
    y2: 373.45
  })), _line291 || (_line291 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 568.32,
    y1: 369.22,
    x2: 606.73,
    y2: 369.22
  })), _line292 || (_line292 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 568.32,
    y1: 369.22,
    x2: 568.32,
    y2: 367.14
  })), _line293 || (_line293 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 565.28,
    y1: 367.14,
    x2: 568.32,
    y2: 367.14
  })), _line294 || (_line294 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 606.73,
    y1: 331.04,
    x2: 565.28,
    y2: 331.04
  })), _line295 || (_line295 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 606.73,
    y1: 369.22,
    x2: 606.73,
    y2: 331.04
  })), _line296 || (_line296 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 565.28,
    y1: 367.14,
    x2: 565.28,
    y2: 331.04
  })), _line297 || (_line297 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 602.33,
    y1: 369.22,
    x2: 602.33,
    y2: 373.45
  })), _line298 || (_line298 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 600.44,
    y1: 369.22,
    x2: 600.44,
    y2: 373.45
  })), _line299 || (_line299 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 665.98,
    y1: 398.4,
    x2: 665.98,
    y2: 388.53
  })), _line300 || (_line300 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 656.66,
    y1: 398.4,
    x2: 656.66,
    y2: 388.53
  })), _polyline69 || (_polyline69 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "652.87 398.92 652.72 398.92 652.72 399.52"
  })), _polyline70 || (_polyline70 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "652.72 412.37 652.72 412.52 652.87 412.52"
  })), _polyline71 || (_polyline71 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "667.64 412.52 667.87 412.52 667.87 412.37"
  })), _polyline72 || (_polyline72 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "667.87 399.52 667.87 398.92 667.64 398.92"
  })), _line301 || (_line301 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 667.64,
    y1: 412.52,
    x2: 652.87,
    y2: 412.52
  })), _line302 || (_line302 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 667.87,
    y1: 399.52,
    x2: 667.87,
    y2: 412.37
  })), _line303 || (_line303 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 652.87,
    y1: 398.92,
    x2: 667.64,
    y2: 398.92
  })), _line304 || (_line304 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 665.37,
    y1: 419.2,
    x2: 665.37,
    y2: 412.74
  })), _line305 || (_line305 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 655.14,
    y1: 419.2,
    x2: 655.14,
    y2: 412.74
  })), _line306 || (_line306 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 656.66,
    y1: 398.4,
    x2: 665.98,
    y2: 398.4
  })), _line307 || (_line307 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 656.66,
    y1: 388.53,
    x2: 665.98,
    y2: 388.53
  })), _line308 || (_line308 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 655.14,
    y1: 419.2,
    x2: 665.37,
    y2: 419.2
  })), _line309 || (_line309 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 652.72,
    y1: 412.37,
    x2: 652.72,
    y2: 399.52
  })), _line310 || (_line310 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 651.35,
    y1: 393.35,
    x2: 651.35,
    y2: 419.79
  })), _line311 || (_line311 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 667.87,
    y1: 419.79,
    x2: 667.87,
    y2: 432.79
  })), _line312 || (_line312 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 667.87,
    y1: 432.79,
    x2: 628.85,
    y2: 432.79
  })), _line313 || (_line313 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 651.35,
    y1: 393.35,
    x2: 628.85,
    y2: 393.35
  })), _line314 || (_line314 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 628.85,
    y1: 393.35,
    x2: 628.85,
    y2: 432.79
  })), _line315 || (_line315 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 651.35,
    y1: 419.79,
    x2: 667.87,
    y2: 419.79
  })), _line316 || (_line316 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 628.85,
    y1: 432.79,
    x2: 628.85,
    y2: 431.9
  })), _line317 || (_line317 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 661.43,
    y1: 373.45,
    x2: 661.43,
    y2: 388.38
  })), _line318 || (_line318 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 653.48,
    y1: 373.45,
    x2: 658.17,
    y2: 373.45
  })), _line319 || (_line319 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 653.48,
    y1: 388.38,
    x2: 661.43,
    y2: 388.38
  })), _line320 || (_line320 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 653.48,
    y1: 373.45,
    x2: 653.48,
    y2: 388.38
  })), _line321 || (_line321 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 660.07,
    y1: 373.45,
    x2: 661.43,
    y2: 373.45
  })), _line322 || (_line322 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 625.67,
    y1: 369.22,
    x2: 664.08,
    y2: 369.22
  })), _line323 || (_line323 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 625.67,
    y1: 369.22,
    x2: 625.67,
    y2: 367.14
  })), _line324 || (_line324 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 623.02,
    y1: 367.14,
    x2: 625.67,
    y2: 367.14
  })), _line325 || (_line325 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 664.08,
    y1: 331.04,
    x2: 623.02,
    y2: 331.04
  })), _line326 || (_line326 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 664.08,
    y1: 369.22,
    x2: 664.08,
    y2: 331.04
  })), _line327 || (_line327 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 623.02,
    y1: 367.14,
    x2: 623.02,
    y2: 331.04
  })), _line328 || (_line328 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 660.07,
    y1: 369.22,
    x2: 660.07,
    y2: 373.45
  })), _line329 || (_line329 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 658.17,
    y1: 369.22,
    x2: 658.17,
    y2: 373.45
  })), _line330 || (_line330 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 725.22,
    y1: 398.4,
    x2: 725.22,
    y2: 388.53
  })), _line331 || (_line331 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 716.13,
    y1: 398.4,
    x2: 716.13,
    y2: 388.53
  })), _polyline73 || (_polyline73 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "712.34 398.92 711.97 398.92 711.74 399.52"
  })), _polyline74 || (_polyline74 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "711.74 412.37 711.97 412.52 712.34 412.52"
  })), _polyline75 || (_polyline75 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "726.51 412.52 726.89 412.52 727.12 412.37"
  })), _polyline76 || (_polyline76 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "727.12 399.52 726.89 398.92 726.51 398.92"
  })), _line332 || (_line332 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 726.51,
    y1: 412.52,
    x2: 712.34,
    y2: 412.52
  })), _line333 || (_line333 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 727.12,
    y1: 399.52,
    x2: 727.12,
    y2: 412.37
  })), _line334 || (_line334 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 712.34,
    y1: 398.92,
    x2: 726.51,
    y2: 398.92
  })), _line335 || (_line335 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 724.62,
    y1: 419.2,
    x2: 724.62,
    y2: 412.74
  })), _line336 || (_line336 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 714.24,
    y1: 419.2,
    x2: 714.24,
    y2: 412.74
  })), _line337 || (_line337 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 716.13,
    y1: 398.4,
    x2: 725.22,
    y2: 398.4
  })), _line338 || (_line338 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 715.75,
    y1: 388.53,
    x2: 725.22,
    y2: 388.53
  })), _line339 || (_line339 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 714.24,
    y1: 419.2,
    x2: 724.62,
    y2: 419.2
  })), _line340 || (_line340 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 711.74,
    y1: 412.37,
    x2: 711.74,
    y2: 399.52
  })), _line341 || (_line341 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 710.45,
    y1: 393.35,
    x2: 710.45,
    y2: 419.79
  })), _line342 || (_line342 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 727.12,
    y1: 419.79,
    x2: 727.12,
    y2: 432.79
  })), _line343 || (_line343 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 727.12,
    y1: 432.79,
    x2: 688.1,
    y2: 432.79
  })), _line344 || (_line344 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 710.45,
    y1: 393.35,
    x2: 688.1,
    y2: 393.35
  })), _line345 || (_line345 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 688.1,
    y1: 393.35,
    x2: 688.1,
    y2: 432.79
  })), _line346 || (_line346 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 710.45,
    y1: 419.79,
    x2: 727.12,
    y2: 419.79
  })), _line347 || (_line347 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 688.1,
    y1: 432.79,
    x2: 688.1,
    y2: 431.9
  })), _line348 || (_line348 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 720.3,
    y1: 373.45,
    x2: 720.3,
    y2: 388.38
  })), _line349 || (_line349 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 712.72,
    y1: 373.45,
    x2: 717.42,
    y2: 373.45
  })), _line350 || (_line350 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 712.72,
    y1: 388.38,
    x2: 720.3,
    y2: 388.38
  })), _line351 || (_line351 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 712.72,
    y1: 373.45,
    x2: 712.72,
    y2: 388.38
  })), _line352 || (_line352 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 718.94,
    y1: 373.45,
    x2: 720.3,
    y2: 373.45
  })), _line353 || (_line353 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 684.84,
    y1: 369.22,
    x2: 723.33,
    y2: 369.22
  })), _line354 || (_line354 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 684.84,
    y1: 369.22,
    x2: 684.84,
    y2: 367.14
  })), _line355 || (_line355 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 682.27,
    y1: 367.14,
    x2: 684.84,
    y2: 367.14
  })), _line356 || (_line356 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 723.33,
    y1: 331.04,
    x2: 682.27,
    y2: 331.04
  })), _line357 || (_line357 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 723.33,
    y1: 369.22,
    x2: 723.33,
    y2: 331.04
  })), _line358 || (_line358 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 682.27,
    y1: 367.14,
    x2: 682.27,
    y2: 331.04
  })), _line359 || (_line359 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 718.94,
    y1: 369.22,
    x2: 718.94,
    y2: 373.45
  })), _line360 || (_line360 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 717.42,
    y1: 369.22,
    x2: 717.42,
    y2: 373.45
  })), _line361 || (_line361 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 784.78,
    y1: 398.4,
    x2: 784.78,
    y2: 388.53
  })), _line362 || (_line362 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 775.53,
    y1: 398.4,
    x2: 775.53,
    y2: 388.53
  })), _polyline77 || (_polyline77 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "771.74 398.92 771.59 398.92 771.59 399.52"
  })), _polyline78 || (_polyline78 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "771.59 412.37 771.59 412.52 771.74 412.52"
  })), _polyline79 || (_polyline79 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "786.29 412.52 786.67 412.52 786.67 412.37"
  })), _polyline80 || (_polyline80 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "786.67 399.52 786.67 398.92 786.29 398.92"
  })), _line363 || (_line363 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 786.29,
    y1: 412.52,
    x2: 771.74,
    y2: 412.52
  })), _line364 || (_line364 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 786.67,
    y1: 399.52,
    x2: 786.67,
    y2: 412.37
  })), _line365 || (_line365 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 771.74,
    y1: 398.92,
    x2: 786.29,
    y2: 398.92
  })), _line366 || (_line366 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 784.25,
    y1: 419.2,
    x2: 784.25,
    y2: 412.74
  })), _line367 || (_line367 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 774.02,
    y1: 419.2,
    x2: 774.02,
    y2: 412.74
  })), _line368 || (_line368 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 775.53,
    y1: 398.4,
    x2: 784.78,
    y2: 398.4
  })), _line369 || (_line369 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 775.53,
    y1: 388.53,
    x2: 784.78,
    y2: 388.53
  })), _line370 || (_line370 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 774.02,
    y1: 419.2,
    x2: 784.25,
    y2: 419.2
  })), _line371 || (_line371 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 771.59,
    y1: 412.37,
    x2: 771.59,
    y2: 399.52
  })), _line372 || (_line372 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 769.85,
    y1: 393.35,
    x2: 769.85,
    y2: 419.79
  })), _line373 || (_line373 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 786.67,
    y1: 419.79,
    x2: 786.67,
    y2: 432.79
  })), _line374 || (_line374 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 786.67,
    y1: 432.79,
    x2: 747.73,
    y2: 432.79
  })), _line375 || (_line375 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 769.85,
    y1: 393.35,
    x2: 747.73,
    y2: 393.35
  })), _line376 || (_line376 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 747.73,
    y1: 393.35,
    x2: 747.73,
    y2: 432.79
  })), _line377 || (_line377 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 769.85,
    y1: 419.79,
    x2: 786.67,
    y2: 419.79
  })), _line378 || (_line378 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 747.73,
    y1: 432.79,
    x2: 747.73,
    y2: 431.9
  })), _line379 || (_line379 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 779.93,
    y1: 373.45,
    x2: 779.93,
    y2: 388.38
  })), _line380 || (_line380 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 772.35,
    y1: 373.45,
    x2: 776.9,
    y2: 373.45
  })), _line381 || (_line381 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 772.35,
    y1: 388.38,
    x2: 779.93,
    y2: 388.38
  })), _line382 || (_line382 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 772.35,
    y1: 373.45,
    x2: 772.35,
    y2: 388.38
  })), _line383 || (_line383 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 778.79,
    y1: 373.45,
    x2: 779.93,
    y2: 373.45
  })), _line384 || (_line384 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 744.47,
    y1: 369.22,
    x2: 782.88,
    y2: 369.22
  })), _line385 || (_line385 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 744.47,
    y1: 369.22,
    x2: 744.47,
    y2: 367.14
  })), _line386 || (_line386 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 741.67,
    y1: 367.14,
    x2: 744.47,
    y2: 367.14
  })), _line387 || (_line387 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 782.88,
    y1: 331.04,
    x2: 741.67,
    y2: 331.04
  })), _line388 || (_line388 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 782.88,
    y1: 369.22,
    x2: 782.88,
    y2: 331.04
  })), _line389 || (_line389 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 741.67,
    y1: 367.14,
    x2: 741.67,
    y2: 331.04
  })), _line390 || (_line390 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 778.79,
    y1: 369.22,
    x2: 778.79,
    y2: 373.45
  })), _line391 || (_line391 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 776.9,
    y1: 369.22,
    x2: 776.9,
    y2: 373.45
  })), _line392 || (_line392 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 843.87,
    y1: 398.4,
    x2: 843.87,
    y2: 388.53
  })), _line393 || (_line393 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 834.55,
    y1: 398.4,
    x2: 834.55,
    y2: 388.53
  })), _polyline81 || (_polyline81 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "830.99 398.92 830.77 398.92 830.39 399.52"
  })), _polyline82 || (_polyline82 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "830.39 412.37 830.77 412.52 830.99 412.52"
  })), _polyline83 || (_polyline83 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "845.39 412.52 845.77 412.52 845.92 412.37"
  })), _polyline84 || (_polyline84 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "845.92 399.52 845.77 398.92 845.39 398.92"
  })), _line394 || (_line394 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 845.39,
    y1: 412.52,
    x2: 830.99,
    y2: 412.52
  })), _line395 || (_line395 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 845.92,
    y1: 399.52,
    x2: 845.92,
    y2: 412.37
  })), _line396 || (_line396 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 830.99,
    y1: 398.92,
    x2: 845.39,
    y2: 398.92
  })), _line397 || (_line397 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 843.49,
    y1: 419.2,
    x2: 843.49,
    y2: 412.74
  })), _line398 || (_line398 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 832.89,
    y1: 419.2,
    x2: 832.89,
    y2: 412.74
  })), _line399 || (_line399 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 834.55,
    y1: 398.4,
    x2: 843.87,
    y2: 398.4
  })), _line400 || (_line400 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 834.55,
    y1: 388.53,
    x2: 843.87,
    y2: 388.53
  })), _line401 || (_line401 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 832.89,
    y1: 419.2,
    x2: 843.49,
    y2: 419.2
  })), _line402 || (_line402 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 830.39,
    y1: 412.37,
    x2: 830.39,
    y2: 399.52
  })), _line403 || (_line403 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 829.1,
    y1: 393.35,
    x2: 829.1,
    y2: 419.79
  })), _line404 || (_line404 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 845.92,
    y1: 419.79,
    x2: 845.92,
    y2: 432.79
  })), _line405 || (_line405 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 845.92,
    y1: 432.79,
    x2: 806.97,
    y2: 432.79
  })), _line406 || (_line406 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 829.1,
    y1: 393.35,
    x2: 806.97,
    y2: 393.35
  })), _line407 || (_line407 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 806.97,
    y1: 393.35,
    x2: 806.97,
    y2: 432.79
  })), _line408 || (_line408 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 829.1,
    y1: 419.79,
    x2: 845.92,
    y2: 419.79
  })), _line409 || (_line409 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 806.97,
    y1: 432.79,
    x2: 806.97,
    y2: 431.9
  })), _line410 || (_line410 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 839.1,
    y1: 373.45,
    x2: 839.1,
    y2: 388.38
  })), _line411 || (_line411 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 831.52,
    y1: 373.45,
    x2: 835.92,
    y2: 373.45
  })), _line412 || (_line412 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 831.52,
    y1: 388.38,
    x2: 839.1,
    y2: 388.38
  })), _line413 || (_line413 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 831.52,
    y1: 373.45,
    x2: 831.52,
    y2: 388.38
  })), _line414 || (_line414 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 837.81,
    y1: 373.45,
    x2: 839.1,
    y2: 373.45
  })), _line415 || (_line415 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 803.72,
    y1: 369.22,
    x2: 842.13,
    y2: 369.22
  })), _line416 || (_line416 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 803.72,
    y1: 369.22,
    x2: 803.72,
    y2: 367.14
  })), _line417 || (_line417 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 801.07,
    y1: 367.14,
    x2: 803.72,
    y2: 367.14
  })), _line418 || (_line418 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 842.13,
    y1: 331.04,
    x2: 801.07,
    y2: 331.04
  })), _line419 || (_line419 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 842.13,
    y1: 369.22,
    x2: 842.13,
    y2: 331.04
  })), _line420 || (_line420 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 801.07,
    y1: 367.14,
    x2: 801.07,
    y2: 331.04
  })), _line421 || (_line421 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 837.81,
    y1: 369.22,
    x2: 837.81,
    y2: 373.45
  })), _line422 || (_line422 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 835.92,
    y1: 369.22,
    x2: 835.92,
    y2: 373.45
  })), _line423 || (_line423 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 903.65,
    y1: 398.4,
    x2: 903.65,
    y2: 388.53
  })), _line424 || (_line424 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 894.41,
    y1: 398.4,
    x2: 894.41,
    y2: 388.53
  })), _polyline85 || (_polyline85 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "890.62 398.92 890.24 398.92 890.01 399.52"
  })), _polyline86 || (_polyline86 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "890.01 412.37 890.24 412.52 890.62 412.52"
  })), _polyline87 || (_polyline87 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "905.01 412.52 905.17 412.52 905.55 412.37"
  })), _polyline88 || (_polyline88 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "905.55 399.52 905.17 398.92 905.01 398.92"
  })), _line425 || (_line425 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 905.01,
    y1: 412.52,
    x2: 890.62,
    y2: 412.52
  })), _line426 || (_line426 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 905.55,
    y1: 399.52,
    x2: 905.55,
    y2: 412.37
  })), _line427 || (_line427 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 890.62,
    y1: 398.92,
    x2: 905.01,
    y2: 398.92
  })), _line428 || (_line428 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 903.12,
    y1: 419.2,
    x2: 903.12,
    y2: 412.74
  })), _line429 || (_line429 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 892.51,
    y1: 419.2,
    x2: 892.51,
    y2: 412.74
  })), _line430 || (_line430 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 894.41,
    y1: 398.4,
    x2: 903.65,
    y2: 398.4
  })), _line431 || (_line431 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 894.03,
    y1: 388.53,
    x2: 903.65,
    y2: 388.53
  })), _line432 || (_line432 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 892.51,
    y1: 419.2,
    x2: 903.12,
    y2: 419.2
  })), _line433 || (_line433 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 890.01,
    y1: 412.37,
    x2: 890.01,
    y2: 399.52
  })), _line434 || (_line434 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 888.73,
    y1: 393.35,
    x2: 888.73,
    y2: 419.79
  })), _line435 || (_line435 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 905.55,
    y1: 419.79,
    x2: 905.55,
    y2: 432.79
  })), _line436 || (_line436 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 905.55,
    y1: 432.79,
    x2: 866.6,
    y2: 432.79
  })), _line437 || (_line437 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 888.73,
    y1: 393.35,
    x2: 866.6,
    y2: 393.35
  })), _line438 || (_line438 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 866.6,
    y1: 393.35,
    x2: 866.6,
    y2: 432.79
  })), _line439 || (_line439 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 888.73,
    y1: 419.79,
    x2: 905.55,
    y2: 419.79
  })), _line440 || (_line440 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 866.6,
    y1: 432.79,
    x2: 866.6,
    y2: 431.9
  })), _line441 || (_line441 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 898.73,
    y1: 373.45,
    x2: 898.73,
    y2: 388.38
  })), _line442 || (_line442 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 891.15,
    y1: 373.45,
    x2: 895.7,
    y2: 373.45
  })), _line443 || (_line443 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 891.15,
    y1: 388.38,
    x2: 898.73,
    y2: 388.38
  })), _line444 || (_line444 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 891.15,
    y1: 373.45,
    x2: 891.15,
    y2: 388.38
  })), _line445 || (_line445 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 897.44,
    y1: 373.45,
    x2: 898.73,
    y2: 373.45
  })), _line446 || (_line446 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 863.19,
    y1: 369.22,
    x2: 901.76,
    y2: 369.22
  })), _line447 || (_line447 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 863.19,
    y1: 369.22,
    x2: 863.19,
    y2: 367.14
  })), _line448 || (_line448 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 860.54,
    y1: 367.14,
    x2: 863.19,
    y2: 367.14
  })), _line449 || (_line449 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 901.76,
    y1: 331.04,
    x2: 860.54,
    y2: 331.04
  })), _line450 || (_line450 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 901.76,
    y1: 369.22,
    x2: 901.76,
    y2: 331.04
  })), _line451 || (_line451 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 860.54,
    y1: 367.14,
    x2: 860.54,
    y2: 331.04
  })), _line452 || (_line452 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 897.44,
    y1: 369.22,
    x2: 897.44,
    y2: 373.45
  })), _line453 || (_line453 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 895.7,
    y1: 369.22,
    x2: 895.7,
    y2: 373.45
  })), _line454 || (_line454 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 962.52,
    y1: 398.4,
    x2: 962.52,
    y2: 388.53
  })), _line455 || (_line455 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 953.43,
    y1: 398.4,
    x2: 953.43,
    y2: 388.53
  })), _polyline89 || (_polyline89 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "949.64 398.92 949.26 398.92 949.26 399.52"
  })), _polyline90 || (_polyline90 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "949.26 412.37 949.26 412.52 949.64 412.52"
  })), _polyline91 || (_polyline91 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "964.26 412.52 964.41 412.52 964.41 412.37"
  })), _polyline92 || (_polyline92 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "964.41 399.52 964.41 398.92 964.26 398.92"
  })), _line456 || (_line456 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 964.26,
    y1: 412.52,
    x2: 949.64,
    y2: 412.52
  })), _line457 || (_line457 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 964.41,
    y1: 399.52,
    x2: 964.41,
    y2: 412.37
  })), _line458 || (_line458 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 949.64,
    y1: 398.92,
    x2: 964.26,
    y2: 398.92
  })), _line459 || (_line459 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 961.99,
    y1: 419.2,
    x2: 961.99,
    y2: 412.74
  })), _line460 || (_line460 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 951.76,
    y1: 419.2,
    x2: 951.76,
    y2: 412.74
  })), _line461 || (_line461 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 953.43,
    y1: 398.4,
    x2: 962.52,
    y2: 398.4
  })), _line462 || (_line462 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 953.43,
    y1: 388.53,
    x2: 962.52,
    y2: 388.53
  })), _line463 || (_line463 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 951.76,
    y1: 419.2,
    x2: 961.99,
    y2: 419.2
  })), _line464 || (_line464 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 949.26,
    y1: 412.37,
    x2: 949.26,
    y2: 399.52
  })), _line465 || (_line465 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 947.97,
    y1: 393.35,
    x2: 947.97,
    y2: 419.79
  })), _line466 || (_line466 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 964.41,
    y1: 419.79,
    x2: 964.41,
    y2: 432.79
  })), _line467 || (_line467 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 964.41,
    y1: 432.79,
    x2: 925.4,
    y2: 432.79
  })), _line468 || (_line468 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 947.97,
    y1: 393.35,
    x2: 925.4,
    y2: 393.35
  })), _line469 || (_line469 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 925.4,
    y1: 393.35,
    x2: 925.4,
    y2: 432.79
  })), _line470 || (_line470 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 947.97,
    y1: 419.79,
    x2: 964.41,
    y2: 419.79
  })), _line471 || (_line471 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 925.4,
    y1: 432.79,
    x2: 925.4,
    y2: 431.9
  })), _line472 || (_line472 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 957.97,
    y1: 373.45,
    x2: 957.97,
    y2: 388.38
  })), _line473 || (_line473 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 950.02,
    y1: 373.45,
    x2: 954.79,
    y2: 373.45
  })), _line474 || (_line474 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 950.02,
    y1: 388.38,
    x2: 957.97,
    y2: 388.38
  })), _line475 || (_line475 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 950.02,
    y1: 373.45,
    x2: 950.02,
    y2: 388.38
  })), _line476 || (_line476 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 956.69,
    y1: 373.45,
    x2: 957.97,
    y2: 373.45
  })), _line477 || (_line477 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 922.59,
    y1: 369.22,
    x2: 961,
    y2: 369.22
  })), _line478 || (_line478 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 922.59,
    y1: 369.22,
    x2: 922.59,
    y2: 367.14
  })), _line479 || (_line479 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 919.56,
    y1: 367.14,
    x2: 922.59,
    y2: 367.14
  })), _line480 || (_line480 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 961,
    y1: 331.04,
    x2: 919.56,
    y2: 331.04
  })), _line481 || (_line481 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 961,
    y1: 369.22,
    x2: 961,
    y2: 331.04
  })), _line482 || (_line482 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 919.56,
    y1: 367.14,
    x2: 919.56,
    y2: 331.04
  })), _line483 || (_line483 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 956.69,
    y1: 369.22,
    x2: 956.69,
    y2: 373.45
  })), _line484 || (_line484 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 954.79,
    y1: 369.22,
    x2: 954.79,
    y2: 373.45
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 242.33,
    y: 254.66,
    width: 800,
    height: 64.35
  })), _line485 || (_line485 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 255.06,
    y1: 376.42,
    x2: 996.57,
    y2: 376.42
  })), _line486 || (_line486 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 252.26,
    y1: 467.03,
    x2: 993.77,
    y2: 467.03
  })), _line487 || (_line487 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 251.36,
    y1: 324.09,
    x2: 251.36,
    y2: 466.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamiMapsCpSubArea2);
export default __webpack_public_path__ + "static/media/NAMI Maps_CP Sub Area 2.27a537e09fd3afe741ce5c85dfc4f272.svg";
export { ForwardRef as ReactComponent };